import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FileUploadUtils} from "../../../utils/FileUploadUtils";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "名字",
        key: "name",
        type: "input",
        required: true,
    },
    {
        name: "数量",
        key: "count",
        type: "number",
        required: true,
    },
    {
        name: "坐标",
        key: "coordinates",
        type: "input",
        required: true,
    },
]

const NewStratumWorkUnitEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})

    let changedForms = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.newStratum.workUnit.get(guid)
                .onSuccess(data => {
                    setInitFormData(data)
                })
        }
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }


    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.newStratum.workUnit.update(form)
        } else {
            return ApiService.admin.newStratum.workUnit.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, {}, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"新社会阶层工作地点编辑"}
                extra={<a href="http://api.map.baidu.com/lbsapi/getpoint/" target="_blank">[拾取坐标系统]</a>}
                formStruct={FORM}
                initValues={initFormData}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
            />
        </>
    )
}

export default NewStratumWorkUnitEditPage